// src/app/redux/reducers/avanceReducer.js
import {
    FETCH_AVANCE_REQUEST,
    FETCH_AVANCE_SUCCESS,
    FETCH_AVANCE_FAIL,
    FETCH_AVANCE_BY_ID_SUCCESS,
    SET_AVANCE_LOADING,
    CLEAR_AVANCE_ERROR,
    CREATE_AVANCE_SUCCESS,
    UPDATE_AVANCE_SUCCESS,
    UPDATE_AVANCE_FAIL,
    DELETE_AVANCE_SUCCESS,
    FETCH_AVANCE_ACTIFS_SUCCESS,
} from "../actions/avanceActions";

const initialState = {
    loading: false,
    error: null,
    avances: [],
    currentAvance: null,
    avancesActives: [],
};

export default function avanceReducer(state = initialState, action) {
    switch (action.type) {
        case SET_AVANCE_LOADING:
            return { ...state, loading: action.payload };

        case CLEAR_AVANCE_ERROR:
            return { ...state, error: null };

        case FETCH_AVANCE_REQUEST:
            return { ...state, loading: true, error: null };

        case FETCH_AVANCE_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                avances: action.payload || [],
            };

        case FETCH_AVANCE_FAIL:
            return { ...state, loading: false, error: action.payload };

        case FETCH_AVANCE_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                currentAvance: action.payload,
            };

        case CREATE_AVANCE_SUCCESS:
            return {
                ...state,
                loading: false,
                avances: [action.payload, ...state.avances],
            };

        case UPDATE_AVANCE_SUCCESS: {
            const updated = action.payload;
            return {
                ...state,
                loading: false,
                avances: (state.avances || []).map((a) =>
                    a.id === updated.id ? updated : a
                ),
                currentAvance: state.currentAvance?.id === updated.id
                    ? updated
                    : state.currentAvance,
            };
        }

        case UPDATE_AVANCE_FAIL:
            return { ...state, loading: false, error: action.payload };

        case DELETE_AVANCE_SUCCESS:
            return {
                ...state,
                loading: false,
                avances: state.avances.filter((a) => a.id !== action.payload),
            };

        case FETCH_AVANCE_ACTIFS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                avancesActives: action.payload || [],
            };

        default:
            return state;
    }
}